import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function SocialProof() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    quote: t('social.1.quote'),
    author: t('social.1.author'),
    detail: t('social.1.detail')
  }, {
    quote: t('social.2.quote'),
    author: t('social.2.author'),
    detail: t('social.2.detail')
  }, {
    quote: t('social.3.quote'),
    author: t('social.3.author'),
    detail: t('social.3.detail')
  }];
  return <section className="py-14 md:py-20 bg-[#f4f4f4]" data-track="social-proof" data-id="element-175">
      <div className="container mx-auto px-5 md:px-6" data-id="element-176">
        <div className="text-center mb-8 md:mb-14" data-id="element-177">
          <motion.h2 className="text-2xl md:text-4xl font-black text-[#111111] uppercase tracking-tight mb-1" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-178">
            {t('social.title')}
          </motion.h2>
          <p className="text-[#6b6b6b] text-sm mb-5" data-id="element-179">{t('social.sub')}</p>

          {/* Mitchell avatar + Google Rating */}
          <div className="flex flex-col items-center gap-4 mb-6" data-id="element-180">
            <motion.div className="relative" initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} data-id="element-181">
              <img src="https://cdn.magicpatterns.com/uploads/iHF7LWorVrm1oxJEBQvudf/mitchell_cars_kia_.jpg" alt="Mitchell The Kia Boss" className="w-24 h-24 md:w-28 md:h-28 rounded-full object-cover object-top border-4 border-[#C41230] shadow-xl" data-id="element-182" />
              <div className="absolute -bottom-1 -right-1 bg-[#C41230] text-white text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded-full" data-id="element-183">
                The Boss
              </div>
            </motion.div>

            {/* Google Rating Badge */}
            <motion.div className="inline-flex items-center gap-3 bg-white rounded-full px-5 py-2.5 shadow-sm border border-[#e5e5e5]" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-184">
              <div className="flex gap-0.5" data-id="element-185">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-[#C41230] fill-[#C41230]" data-id="element-186" />)}
              </div>
              <span className="font-bold text-[#111111] text-sm" data-id="element-187">
                {t('social.rating')}
              </span>
              <span className="text-[#d4a853] text-xs" data-id="element-188">•</span>
              <span className="text-[#6b6b6b] text-xs" data-id="element-189">
                {t('social.reviews')}
              </span>
            </motion.div>
          </div>
        </div>

        {/* Testimonials */}
        <div className="flex md:grid md:grid-cols-3 gap-4 overflow-x-auto pb-4 md:pb-0 snap-x snap-mandatory -mx-5 px-5 md:mx-0 md:px-0 scrollbar-hide" data-id="element-190">
          {testimonials.map((item, i) => <motion.div key={i} className="min-w-[280px] md:min-w-0 snap-center bg-white p-5 md:p-7 rounded-xl border border-[#e5e5e5] shadow-sm flex flex-col" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} data-id="element-191">
              <div className="flex gap-0.5 mb-3" data-id="element-192">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 text-[#C41230] fill-[#C41230]" data-id="element-193" />)}
              </div>
              <p className="text-[#111111] text-sm md:text-base mb-4 flex-1 leading-relaxed" data-id="element-194">
                "{item.quote}"
              </p>
              <div data-id="element-195">
                <p className="font-bold text-[#111111] text-sm" data-id="element-196">
                  {item.author}
                </p>
                <p className="text-[11px] text-[#C41230] font-medium" data-id="element-197">
                  {item.detail}
                </p>
                <p className="text-[10px] text-[#6b6b6b] uppercase tracking-wider mt-0.5" data-id="element-198">
                  {t('social.role')}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}